/**
 * Humanize a snake_case / kebab-case tag for display.
 * e.g. "open_to_relocation" → "Open to relocation", "#data-science" → "Data science".
 */
export function humanizeTag(tag: string): string {
  const cleaned = tag
    .replace(/^#+/, '')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  if (!cleaned) return '';
  return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
}
